import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../components/WebView/icons/Close.svg'
import _imports_1 from '../../../components/WebView/icons/BackLeftAction.svg'
import _imports_2 from '../../../components/WebView/icons/More.svg'


const _withScopeId = n => (_pushScopeId("data-v-b5a7f902"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Close"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Back"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "custom-title-header"
}
const _hoisted_7 = {
  key: 1,
  class: "custom-title-center"
}
const _hoisted_8 = { class: "light-text" }
const _hoisted_9 = {
  key: 2,
  class: "custom-title-center"
}
const _hoisted_10 = {
  key: 3,
  class: "custom-title-center"
}
const _hoisted_11 = {
  key: 4,
  class: "nav-header-chat"
}
const _hoisted_12 = { class: "score" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "flex-container" }
const _hoisted_15 = { class: "name" }
const _hoisted_16 = { class: "email" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Actions"
}, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "locked-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaseStatusRow = _resolveComponent("CaseStatusRow")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, { "no-pad": "" }, {
    "left-button": _withCtx(() => [
      (_ctx.onRoot)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "header-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_2))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "header-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, _hoisted_4))
    ]),
    "custom-title": _withCtx(() => [
      (_ctx.composable.loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.onCase)
              ? (_openBlock(), _createBlock(_component_CaseStatusRow, {
                  key: 0,
                  class: "case-status-header",
                  "question-id": _ctx.chatQuestionId,
                  "chat-custom-data": _ctx.chatCustomData,
                  "case-status": _ctx.composable.caseStatus.value
                }, null, 8, ["question-id", "chat-custom-data", "case-status"]))
              : _createCommentVNode("", true),
            (_ctx.onCustomData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createTextVNode(" Custom Data "),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.chatCustomFields.length), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.onTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Reply Template "))
              : _createCommentVNode("", true),
            (_ctx.onWorkflow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Workflows "))
              : _createCommentVNode("", true),
            (
                        !_ctx.onCase && !_ctx.onCustomData && !_ctx.onTemplate && !_ctx.onWorkflow
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["circle", _ctx.composable.circleClass.value])
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.chatCustomData.answer), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.chatCustomData.person_name), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.chatCustomData.person_email), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    "right-button": _withCtx(() => [
      (_ctx.shouldDisplayAction)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            class: "header-button",
            to: {
                    name: 'chatResponsesActions',
                    params: { id: _ctx.chatQuestionId },
                }
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              (_ctx.composable.chatForwardingLocked.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], undefined, true),
    _: 3
  }))
}